import { Injectable } from '@angular/core';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

import { RestService } from './rest.service';

@Injectable()
export class CommitteeService {
  constructor(private readonly rest: RestService) {}

  getCommittees(search: string = ''): Promise<any> {
    const query = objectToQueryString({
      search,
    });

    return this.rest.get(`${environment.apiUrl}/api/core/committee${query}`);
  }

  getCommitteeById(id: number): Promise<any> {
    return this.rest.get(`${environment.apiUrl}/api/core/committee/${id}`);
  }

  createCommittee(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/committee`, payload);
  }

  bulkAssignDelegates(payload: any): Promise<any> {
    return this.rest.post(`${environment.apiUrl}/api/core/committee/!bulkAssign`, payload);
  }

  updateCommittee(id: number, payload: any): Promise<any> {
    return this.rest.put(`${environment.apiUrl}/api/core/committee/${id}`, payload);
  }

  deleteCommittee(id: number): Promise<any> {
    return this.rest.delete(`${environment.apiUrl}/api/core/committee/${id}`);
  }
}
